import React  from 'react'
import {Tabs, Tab, AppBar} from '@material-ui/core';
import config from '../clientConfig';
import themeService from '../themes/themeService';

const { palette } = themeService.getTheme();

const styles = {
    tabs: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-around'
    },
    h2: {
        color: palette.secondary.main
    },
    pageContent: {
        margin: '1rem'
    }
}

const tabs = {
    'customerInfo': 0,
    'viewInvoices': 1,
    'viewShopInvoices': 2,
    'createInvoice': 3,
    'createShopInvoice':4,
    'createLoadInvoice':5,
    'viewLoadInvoices' : 6
};

function CustomerActivityAppBar(props) {
    const {history, match, tab, Component} = props;
    const {customerId} = match.params;
    return (        
        <div>
            <AppBar position="sticky" >
                <Tabs className='customer-activity-tabs'
                    value={tabs[tab]}
                    variant="fullWidth"
                    style={styles.tabs}>
                    <Tab
                        value={tabs.customerInfo}
                        className="button-tab customer-info"
                        label="Customer Info"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/edit` }) }}/>
                    <Tab
                        value={tabs.viewInvoices}
                        label="View Tow Invoices"
                        className="button-tab view-invoices"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/invoices` }) }}/>
                    {config.isPetroff ?  <Tab
                        value={tabs.viewLoadInvoices}
                        label="View Load Invoices"
                        className="button-tab view-load-invoices"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/loadinvoices` }) }}/> : <Tab
                        value={tabs.viewShopInvoices}
                        label="View Shop Invoices"
                        className="button-tab view-tow-invoices"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/shopinvoices` }) }}/>}
                    <Tab
                        value={tabs.createInvoice}
                        label="Create Tow Invoice"
                        className="button-tab create-invoice"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/createinvoice` }) }}/>
                    {config.isPetroff ? <Tab
                        value={tabs.createLoadInvoice}
                        label="Create Load Invoice"
                        className="button-tab create-load-invoice"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/createloadinvoice` }) }}/> : 
                        <Tab
                        value={tabs.createShopInvoice}
                        label="Create Shop Invoice"
                        className="button-tab create-shop-invoice"
                        onClick={(e) => { e.preventDefault(); history.push({ pathname: `/customer/${customerId}/createshopinvoice` }) }}
                    />}
                </Tabs>
            </AppBar>
                <Component {...props} />
        </div>

    )
}


export default CustomerActivityAppBar;